import { useMutation } from "@tanstack/react-query";
import fetcher from "src/utils/fetcher";
import { Listing } from "src/types/listing";

interface AreaProAreaLink {
  url: string;
  label: string;
}

interface AreaProInsightsResponse {
  remo: {
    county: AreaProAreaLink;
    city: AreaProAreaLink;
    zip: AreaProAreaLink;
    mls: AreaProAreaLink;
  };
  address: string;
}

export const useAreaProInsights = () => {
  return useMutation({
    mutationFn: async (listing: Listing): Promise<string> => {
      const address = listing.address;

      const response = await fetcher({
        url: "/api/integrations/areapro/insights",
        method: "POST",
        body: {
          street_address: address?.streetAddress || "",
          secondary_address: address?.unit || "",
          city: address?.city || "",
          state: address?.state || "",
          postal_code: address?.postalCode || "",
          country: "USA",
        },
      });
      const data = response.data as AreaProInsightsResponse;
      return data.remo.city.url;
    },
  });
};
